import styled from "styled-components";

export const HeaderWrapper = styled.div`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: block;
  }
`;
export const StyledSingleReservationScreen = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  padding: 30px 30px 30px 30px;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  gap: 30px;
  position: relative;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 5% 30%;
  }

  .access-code {
    background: lemonchiffon;
    padding: 20px;
    border-radius: 8px;
    margin-top: 20px;
    span {
      font-size: 14px;
    }
    strong {
      font-weight: 600;
    }
  }

  .dropdown-container {
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 14px;
  }

  .dropdown-menu {
    position: absolute;
    top: calc(100% + 8px);
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    background: ${({ theme }) => theme.colors.card};
    color: ${({ theme }) => theme.colors.text};
    font-size: 12px;
    border: 1px solid #ddd;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 8px 0;
    min-width: 200px;
    z-index: 1000;
  }

  .dropdown-item {
    padding: 10px;
    cursor: pointer;
    transition: background 0.2s;
  }

  .dropdown-item:hover {
    background: #f5f5f5;
  }

  .vertical-flex {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    transform: translateY(50%);
  }
  .copy-btn {
    height: 40px;
    width: 40px;
    background-color: ${({ theme }) => theme.colors.background};
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 20px;
    }
  }
  .advice-box {
    background-color: ${({ theme }) => theme.colors.primary30};
    color: ${({ theme }) => theme.colors.text};
    padding: 20px;
    border-radius: 12px;
    margin-top: 20px;
    box-shadow: ${({ theme }) =>
      theme.colors.card === theme.card
        ? theme.boxShadows.dark
        : theme.boxShadows.light};
    h2 {
      font-size: 24px;
    }
    p {
      color: ${({ theme }) => theme.colors.text};
    }
  }
  .weather-box {
    background-color: ${({ theme }) => theme.colors.primary30};
    color: ${({ theme }) => theme.colors.text};
    min-height: 80px;
    margin-top: 20px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 20px;
    box-shadow: ${({ theme }) =>
      theme.colors.card === theme.card
        ? theme.boxShadows.dark
        : theme.boxShadows.light};
    .emoji {
      font-size: 44px;
    }
    .weather-deg {
      font-size: 44px;
    }
    p {
      font-size: 16px;
      margin: 0;
    }
  }
  .grid-div {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    gap: 12px;
    transition: all 0.3s ease; /* Smooth transition */

    .box {
      background-color: ${({ theme }) => theme.colors.card};
      box-sizing: border-box;
      border-radius: 12px;
      width: calc(50% - 6px);
      padding: 24px 24px;
      cursor: pointer;
      transform: translateY(0);
      opacity: 1;

      transition: transform 0.4s ease-in, opacity 0.4s ease-in;

      &:hover {
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
      }
      .title {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        display: flex;
        align-items: center;
        color: ${({ theme }) => theme.colors.text};
        gap: 6px;
        margin-bottom: 20px;
        img {
          height: 24px;
          filter: ${({ theme }) =>
            theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
        }
      }
      span {
        font-size: 34px;
      }
    }
    .box.expanded {
      width: 100%;
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: start;
      background-color: ${({ theme }) => theme.colors.card};
      position: fixed;
      top: 60vh;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1000;
      overflow-y: auto;
      padding-bottom: 20px;
      transform: translateY(0);
      transition: transform 0.4s ease-in, opacity 0.4s ease-in;

      animation: slide-up 0.4s forwards ease-in-out;
      h3 {
        font-size: 24px;
      }
      p {
        font-size: 16px;
        margin-top: 20px;
      }
      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
        width: 40%;
        left: 30%;
        top: 2%;
        bottom: 2%;
      }
    }
  }

  .tab {
    background-color: ${({ theme }) => theme.colors.card};
    padding: 6px 12px;
    font-size: 12px;
    border-radius: 15px;
    color: ${({ theme }) => theme.colors.text};
    border-color: ${({ theme }) => theme.colors.text};
    border: 1px solid;
    font-weight: 500;
  }

  .circle {
    cursor: pointer;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    background-color: ${({ theme }) => theme.colors.background};
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      position: absolute;
      top: 1%;
    }
    img {
      height: 24px;
      width: auto;
    }
  }

  .go-back {
    display: flex;
    z-index: 9;
    background-color: ${({ theme }) => theme.colors.backgroundOpacity90};
    color: ${({ theme }) => theme.colors.text};

    img {
      filter: ${({ theme }) =>
        theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      display: none;
    }
  }

  .password-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .unlock {
    position: sticky;
    top: 12px;
    left: auto;
    transform: none;
    max-width: fit-content;
    min-width: max-content;
    padding: 0px 25px;
    font-size: 14px;
    z-index: 9;
    background-color: ${({ theme }) => theme.colors.backgroundOpacity90};
    color: ${({ theme }) => theme.colors.text};
    border: 1px solid;
    border-color: ${({ theme }) => theme.colors.background};
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    height: 44px;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.35s ease-in;
    span {
      font-size: 20px;
    }
    &:hover {
      background-color: ${({ theme }) => theme.colors.background};
    }
    margin-top: 14px;
    margin-left: auto;
    margin-right: auto;
  }

  .cover-photo {
    height: 65vh;
    width: 100%;
    object-fit: cover;
    object-position: center bottom;
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
    transition: all 0.3s ease;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      position: relative;
      height: 75vh;
    }
  }

  .flex-div {
    gap: 6px;
    margin-top: 10px;
    p {
      padding: 0;
      margin: 0;
    }
  }

  span {
    color: ${({ theme }) => theme.colors.text};
    opacity: 0.7;
    font-size: 12px;
  }

  h2 {
    color: ${({ theme }) => theme.colors.text};
    font-size: 20px;
    font-weight: 600;
    margin: 12px 0 6px 0;
    line-height: 22px;
  }

  p {
    color: ${({ theme }) => theme.colors.text};
    font-size: 13px;
  }

  .info-section {
    margin-top: 65vh;
    transition: all 0.3s ease;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      margin-top: 0px;
      transition: none;
    }
  }

  .expanded-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    transform: translateY(100%);
    animation: slide-up 0.4s forwards ease-in-out;
    p {
      color: ${({ theme }) => theme.colors.text};
    }
  }

  @keyframes slide-up {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  &.scrolled {
    .cover-photo {
      height: 25vh;
      transition: all 0.3s ease;
    }
    .box.expanded {
      top: 25vh;
      transition: all 0.3s ease;
    }

    .info-section {
      margin-top: 36vh;
      transition: all 0.3s ease;
      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
        margin-top: 0px;
        transition: none;
      }
    }
  }

  @keyframes slide-down {
    from {
      transform: translateY(0);
      opacity: 1;
    }
    to {
      transform: translateY(100%);
      opacity: 0;
    }
  }

  .box:not(.expanded) .expanded-content {
    animation: slide-down 0.4s forwards ease-in-out;
  }
`;

export const StyledHorizontalCarousel = styled.div`
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  gap: 24px;
  /* Hide the scrollbar for WebKit browsers (Chrome, Safari) */
  &::-webkit-scrollbar {
    display: none;
  }

  /* If you want to hide the scrollbar for Firefox */
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
`;
